<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="150px">
    <div class="flex-item">
      <div>
        <el-col :span="8">
          <el-form-item label="区域" prop="fRegionID">
            <el-select-ex
              v-model="form.fRegionID"
              url="BasicInformation/Region/RegionEntry"
              label-field="fName"
              value-field="fRegionID"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="帐号" prop="userNumber">
            <el-input v-model="form.userNumber" :readonly="isEdit" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="密码" prop="fPassword">
            <el-input
              v-model="form.fPassword"
              show-password
              :disabled="isEdit"
            />
          </el-form-item>
        </el-col>
      </div>
      <div>
        <el-col :span="8">
          <el-form-item label="名称" prop="fName">
            <el-input v-model="form.fName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="负责人" prop="fCorperate">
            <el-input v-model="form.fCorperate" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="经销商级别" prop="fLevel">
            <el-select v-model="form.fLevel" style="width: 100%">
              <el-option :value="1" label="1" />
              <el-option :value="2" label="2" />
              <el-option :value="3" label="3" />
            </el-select>
          </el-form-item>
        </el-col>
      </div>
      <div>
        <el-col :span="8">
          <el-form-item label="默认扣款比例(%)" prop="fDeductionRatio">
            <el-input-currency
              v-model="form.fDeductionRatio"
              :scale="2"
              min="0"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电话">
            <el-input v-model="form.fPhone" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机">
            <el-input v-model="form.fMobilePhone" />
          </el-form-item>
        </el-col>
      </div>
      <div>
        <el-col :span="8">
          <el-form-item label="E-Mail">
            <el-input v-model="form.fEmail" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="常驻地址">
            <el-input v-model="form.fAddress" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="简介">
            <el-input v-model="form.fDes" />
          </el-form-item>
        </el-col>
      </div>
      <div>
        <el-col :span="8">
          <el-form-item label="按名称导入金蝶">
            <el-checkbox v-model="form.fKdISName" />
          </el-form-item>
        </el-col>
      </div>
    </div>
  </el-form>
</template>

<script>
import md5 from "md5";

export default {
  props: {
    form: Object,
  },
  data: function () {
    return {
      rules: {
        fRegionID: [{ required: true, message: "必填项", trigger: "change" }],
        userNumber: [{ required: true, message: "必填项", trigger: "change" }],
        fPassword: [{ required: true, message: "必填项", trigger: "change" }],
        fName: [{ required: true, message: "必填项", trigger: "change" }],
        fCorperate: [{ required: true, message: "必填项", trigger: "change" }],
        fLevel: [{ required: true, message: "必填项", trigger: "change" }],
        fDeductionRatio: [
          { required: true, message: "必填项", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    isEdit: function () {
      return !!this.form.fDistributorID;
    },
  },
  mounted: function () {},
  methods: {
    submit: function (onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          var data = Object.assign({}, this.form);
          if (!this.isEdit) {
            var user = this.form.userNumber;
            var pw = this.form.fPassword;
            data.fPassword = md5(user + pw + user).toUpperCase();
          }
          onValid(data);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flex-item {
  display: flex;
  width: 95%;
  flex-direction: column;

  & > .el-form-item {
    flex: 0 0 25%;
    display: flex;

    & .el-input,
    &.el-select {
      width: 100%;
    }
  }
}
</style>
